import { useContext, useState } from 'react';
import { UserContext } from '../context/UserContext';
import { MenuContext } from '../context/MenuContext';
import { AiOutlineMenu } from "react-icons/ai";
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';

export function TopBar({title}) {
  const { menuOpen, setMenuOpen } = useContext(MenuContext)
  // const navigate = useNavigate();
  const [cookies] = useCookies();

  return (
    <div className="px-10 py-4 flex justify-between items-center mb-0 border-b border-1 md:border-0 sticky md:relative top-0 z-[48] md:z-[1] bg-white">
        <h2 className="text-md text-[#000000] font-semibold">{cookies?.userProfile?.name} ({cookies?.userProfile?.role})</h2>
        <div
            onClick={() => {setMenuOpen(true); console.log(menuOpen)}}
            className="flex cursor-pointer items-center justify-center lg:hidden"
        >
            <AiOutlineMenu size={20} />
            <h2 className="ml-3 block lg:hidden text-md lg:text-xl font-semibold">Menu</h2>
        </div>
    </div>
  )
}